export const setInspectionSettlement = async (context, inspectionSettlement) => {
  // const result = await inspection.get(id)
  context.commit('SET_INSPECTION_SETTLEMENT', inspectionSettlement)
}

// export const setInspectiontes = async (context, id) => {
//   // const result = await inspection.get(id)
//   context.commit('SET_INSPECTION', result.data)
// }
